import React, { useState, useEffect } from "react";
import firebase from "../util/firebase";
import GridCard from "../components/GridCard";
import { useAuth } from "../context/auth-context";
import { useNavigate, Link } from "react-router-dom";

export default function LogoSelect() {
  const { currentUser } = useAuth();
  const history = useNavigate();
  const [brands, setBrands] = useState([]);
  const [brand, setBrand] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setBrands([]);

    const brandData = firebase
      .firestore()
      .collection("brands")
      .orderBy("Orderby")
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          const data = doc.data();
          if (data.showOnFlyerGenerator === true) {
            setBrands((brands) => [
              ...brands,
              { ...data, id: doc.id, selected: false },
            ]);
          }
        });
        console.log("Finished processing documents");
      })
      .catch((error) => {
        console.error("Error getting documents: ", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const updateBrand = (brand) => {
    currentUser.brand = brand;
    return history("/select-flyer");
  };

  return (
    <>
      {/* {currentUser && (
        <h1 className="text-lg font-semibold text-blue-primary pb-12 -mt-12">
          Hi {currentUser.userData.FirstName}
        </h1>
      )} */}
      <div className="mt-8 pb-20">
        <div className=" mx-auto px-4 lg:px-2 flex justify-center items-center">
          <div className="flex justify-center">
            <ul
              role="list"
              className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 mx-6"
            >
              {brands.map((brand) => (
                <div className="p-4" key={brand.BrandName}>
                  <GridCard brand={brand} updateBrand={updateBrand} />
                </div>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
